import { render, staticRenderFns } from "./ClaimAccountPersona.vue?vue&type=template&id=6af3679a&scoped=true"
import script from "./ClaimAccountPersona.vue?vue&type=script&lang=ts"
export * from "./ClaimAccountPersona.vue?vue&type=script&lang=ts"
import style0 from "./ClaimAccountPersona.vue?vue&type=style&index=0&id=6af3679a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af3679a",
  null
  
)

export default component.exports